import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeactivateProjectMutationVariables = Types.Exact<{
  input: Types.DeactivateProjectInput;
}>;


export type DeactivateProjectMutation = { __typename?: 'Mutation', deactivateProject?: { __typename?: 'DeactivateProjectPayload', project?: { __typename?: 'Project', id: string, workspaceId: string, archivedAt?: string | null, updatedAt?: string | null } | null } | null };


export const DeactivateProject = /*#__PURE__*/ gql`
    mutation DeactivateProject($input: DeactivateProjectInput!) {
  deactivateProject(input: $input) {
    project {
      id
      workspaceId
      archivedAt
      updatedAt
    }
  }
}
    ` as unknown as DocumentNode<DeactivateProjectMutation, DeactivateProjectMutationVariables>;

          

          export const useDeactivateProjectMutation = (options?:MutationHookOptions<DeactivateProjectMutation, DeactivateProjectMutationVariables>) => useMutation(DeactivateProject, options);
          

          export type DeactivateProjectMutationOptions = MutationHookOptions<DeactivateProjectMutation, DeactivateProjectMutationVariables>;

          

          export type DeactivateProjectMutationResult = ReturnType<typeof useDeactivateProjectMutation>[1];

          
